import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = {
  "data-kt-customer-table-toolbar": "base",
  class: "flex justify-end"
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "flex justify-between card-header border-0" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "my-1" }
const _hoisted_7 = { class: "p-input-icon-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_9 = { class: "card-body pt-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "Actions", -1)
const _hoisted_11 = ["href"]

import { ref, onMounted } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import { useRoute } from "vue-router";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import {
    fetchVariantProductCollection
} from "@/_services/grant/variantProductCollection";
import { ICategory } from "@/models/category/ICategory";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListVariantProductCollection',
  setup(__props) {

const route = useRoute();
const loading = ref<boolean>(true);
const categories: ICategory[] = [];
const tableData = ref<Array<ICategory>>(categories);
const uuidRouteParam = ref<string | null>(null);
const currentPage = ref<number>(0);
const rows = ref<number>(15);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");
const modeSortable = ref<boolean>(false);
const categoryLabel = ref<string>("");
const title = ref<string>("Gérer les collections subventionnables");

onMounted(async () => {
    uuidRouteParam.value = route.params.uuid as string;
    await populateDatatable(rows.value, page.value);
});

const onFilterDt = () => {
    if (criteria.value.trim() != "") {
        populateDatatable(rows.value, page.value, criteria.value.trim());
    }
};

const onClearInputFilter = () => {
    if (criteria.value === "") {
        populateDatatable(rows.value, page.value);
    }
};

const onSort = (e) => {
  const sort = e.sortField
    ? {
      fieldLabel: `order[${e.sortField}]`,
      fieldValue: e.sortOrder === 1 ? 'asc' : 'desc',
    }
    : {};

  modeSortable.value = !!e.sortField;

  populateDatatable(rows.value, page.value, criteria.value, sort);
};

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable(e.rows, e.page + 1, criteria.value);
};

const populateDatatable = async (itemsPerPage, page, criteria?, sort?) => {
    showSpinner();
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchVariantProductCollection(
        itemsPerPage,
        page,
        uuidRouteParam.value,
        criteria,
        sort
    );
    totalRecords.value = totalRecordsDt.value;
    loading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
};

const checkDeleteVariantProductCollection = (category) => {
  swal
    .confirm(
      "Êtes-vous sûr de vouloir archiver la collection ?"
    )
    .then((result) => {
      if (result.isConfirmed) {
        deleteVariantProductCollection(category.uuid);
      }
    });
};

const deleteVariantProductCollection = async (uuidCategory) => {
    await ApiService.delete("admin/variant_product_collection/" + uuidCategory)
        .then(() => {
            swal
                .info("la collection a bien été archivée.")
                .then(() => {
                  populateDatatable(rows.value, page.value, criteria.value);
                });
        })
        .catch(() => {
            swal.error();
            return false;
        });
};

const showSpinner = () => {
    loading.value = true;
}

const hideSpinner = () => {
    loading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(title.value), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'addVariantProductCollection' }))),
        class: "button-add",
        icon: "pi pi-plus",
        "aria-label": "Ajouter une collection",
        label: "Ajouter une collection"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        value: tableData.value,
        rows: rows.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        rowHover: true,
        loading: loading.value,
        rowsPerPageOptions: [15, 25, 100],
        lazy: "",
        paginator: "",
        template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
        onPage: onPaginate,
        onSort: _cache[2] || (_cache[2] = ($event: any) => (onSort($event))),
        removableSort: ""
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_unref(InputText), {
                    type: "text",
                    class: "form-control w-[250px] ps-15",
                    modelValue: criteria.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria).value = $event)),
                    onKeyup: _withKeys(onFilterDt, ["enter"]),
                    placeholder: "Rechercher une catégorie",
                    onInput: onClearInputFilter
                  }, null, 8, ["modelValue", "onKeyup"])
                ])
              ])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucune catégorie trouvée.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(Column), {
              field: "name",
              header: "Nom de la collection",
              sortable: ""
            }),
            _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
              header: _withCtx(() => [
                _hoisted_10
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_component_router_link, {
                  to: { name: 'editSocialEventGrantCollection', params: { uuid: slotProps.data.uuid }}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      type: "button",
                      icon: "pi pi-cog",
                      title: "Éditer",
                      class: "p-edition",
                      style: {"margin-right":"0.5em"}
                    })
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createVNode(_component_router_link, {
                  to: { name: 'editVariantProductCollection', params: { uuid: slotProps.data.uuid }}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      type: "button",
                      icon: "pi pi-pencil",
                      title: "Éditer",
                      class: "p-edition",
                      style: {"margin-right":"0.5em"}
                    })
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createVNode(_unref(Button), {
                  onClick: ($event: any) => (checkDeleteVariantProductCollection(slotProps.data)),
                  type: "button",
                  title: "Supprimer",
                  icon: "pi pi-trash",
                  class: "p-button-danger"
                }, null, 8, ["onClick"]),
                (slotProps.data.hasChildren)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.$router.resolve({name:'listCategories', params: {uuid: slotProps.data.uuid}}).href
                    }, [
                      _createVNode(_unref(Button), {
                        type: "button",
                        icon: "pi pi-eye",
                        title: "Voir les sous-catégories",
                        class: "p-button-success ml-2"
                      })
                    ], 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "currentPage", "loading"])
    ])
  ], 64))
}
}

})